import $ from "jquery";
import { countryState } from "./countryState";

let sortColumn;
let sortColumnIndex;
let sortOrder;
let siteSearchFilters;
let sitesTable;

function init() {
    sortColumn = "";
    sortColumnIndex = 0;
    sortOrder = false;
}

function doSetup() {
    return $.Deferred(function(def) {
        countryState.populateCountriesSelect("#searchCountrySelect", "#searchNaStateSelection").done(function() {
            // Load SearchFilters initially from sessionStorage and set the fields
            // If there weren't any filters in session then create new one
            // Do it after all the selects have been populated
            if (typeof (Storage) !== "undefined" && sessionStorage.getItem("siteSearchFilters") !== null) {
                siteSearchFilters = JSON.parse(sessionStorage.getItem("siteSearchFilters"));
            } else {
                setFilters();
            }
            setFieldsToFilter();
            setEvents();
            populateAreasBySelectedRegions();
            def.resolve();
        });
    });
}

function setEvents() {
    $("#searchCountrySelect").change(function() {
        const selectedCountry = $(this).val();
        countryState.populateStatesSelect("#searchNaStateSelection", "#searchNonNaState", selectedCountry);
    });

    $("[regionId]").click(function() {
        populateAreasBySelectedRegions();
    });
}

function populateAreasBySelectedRegions() {
    const selectedRegionIds = $("[regionId]:checkbox:checked").map(function() {
        return $(this).val();
    }).get();

    if (selectedRegionIds.length === 0) {
        $("#searchRegionsAreaSelect option").show();
    } else {
        $("#searchRegionsAreaSelect option").not(":first").hide();
        $.map(selectedRegionIds, function(val, i) {
            $("#searchRegionsAreaSelect option[data-region='" + val + "']").show();
        });
    }
}

function getFilters() {
    return siteSearchFilters;
}

function setFilters() {
    const searchFilter = {
        active: $("#searchActive").is(":checked"),
        areaId: $("#searchRegionsAreaSelect").find("option:selected").val(),
        countryId: $("#searchCountrySelect").find("option:selected").attr("countryId"),
        countryValue: $("#searchCountrySelect").val(),
        desc: sortOrder,
        inActive: $("#searchInActive").is(":checked"),
        keyword: $("#searchKeyword").val(),
        programId: $("#hdnProgramId").val(),
        regions: [],
        showTraumaCenters: $("#showTraumaCenters-true").is(":checked"),
        sortColumn: sortColumn,
        sortColumnIndex: sortColumnIndex,
        stateId: $("#searchStateSelect").val(),
        stateText: $("#searchNonNaStateInput").val(),
        tagsId: []
    };

    console.log("setFilters", searchFilter);
    console.log("showTraumaCenters", $("#showTraumaCenters-true"));

    $("#divTagsContainer :checked").each(function() {
        searchFilter.tagIds.push($(this).attr("tagId"));
    });
    $("[regionId]:checkbox:checked").each(function() {
        searchFilter.regions.push($(this).attr("regionId"));
    });

    siteSearchFilters = searchFilter;
    putFilterInStorage();

    return siteSearchFilters;
}

function setFieldsToFilter() {
    $("#searchKeyword").val(siteSearchFilters.keyword);
    $("#searchActive").prop("checked", siteSearchFilters.active);
    $("#searchInActive").prop("checked", siteSearchFilters.inActive);
    $("#searchCountrySelect").val(siteSearchFilters.countryValue);
    countryState.populateStatesSelect("#searchNaStateSelection", "#searchNonNaState", siteSearchFilters.countryValue);
    $("#searchStateSelect").val(siteSearchFilters.stateId);
    $("#searchNonNaStateInput").val(siteSearchFilters.stateText);
    $("#searchRegionsAreaSelect").val(siteSearchFilters.areaId);
    $("#showTraumaCenters-true").prop("checked", siteSearchFilters.showTraumaCenters);
    $("#showTraumaCenters-false").prop("checked", !siteSearchFilters.showTraumaCenters);
    for (let intx = 0; intx < siteSearchFilters.tagsId.length; intx++) {
        $("#divTagsContainer [" + siteSearchFilters.tagsId[intx] + "]").prop("checked", "checked");
    }

    //
    // Clear the selected regions setup by the done function on getRegions
    //
    $("[regionId]:checkbox:checked").each(function() {
        $(this).prop("checked", "");
    });
    for (let inty = 0; inty < siteSearchFilters.regions.length; inty++) {
        $("#chkRegion-" + siteSearchFilters.regions[inty]).prop("checked", "checked");
    }

    sortColumn = siteSearchFilters.sortColumn;
    sortColumnIndex = siteSearchFilters.sortColumnIndex;
    sortOrder = siteSearchFilters.desc;
    setSortOrder(sortColumn, sortColumnIndex, sortOrder);
}

function setSortOrder(sortColumn, sortColumnIndex, sortOrder) {
    if (sortColumn !== "undefined" && sortColumn !== "") {
        return;
    }

    if (sortColumn !== null && sortColumnIndex > 0) {
        if (sortOrder) {
            sitesTable.columns[sortColumnIndex].addClass("sorting_desc");
        } else {
            sitesTable.columns[sortColumnIndex].addClass("sorting_asc");
        }
    }
}

function getQueryStringFilters() {
    const filters = getFilters();
    for (const key in filters) {
        if (!filters[key]) {
            delete filters[key];
        }
    }
    return filters;
}

function clearFilters() {
    $("#searchKeyword").val("");
    $("#searchFilters :input").each(function() {
        switch (this.type) {
            case "text":
                $("#searchKeyword").val("");
                break;
            case "textarea":
                $(this).val("");
                break;
            case "checkbox":
                $(this).prop("checked", false);
                $("#searchActive").prop("checked", true);
                $("#searchInActive").prop("checked", false);
                break;
            case "radio":
                $("#showTraumaCenters-true").prop("checked", true);
                break;
            case "select-one":
                $(this).prop("selectedIndex", 0);
                break;
        }
    });

    $("#searchRegionSelect, #searchRegionsAreaSelect, #searchCountrySelect, #searchStateSelect").find("option:selected").prop("selected", false);
    $("#searchStateSelect")
        .find("option")
        .remove()
        .end()
        .append("<option value=\"\">State/Province</option>");

    $("#regionsAreaDiv").show();
    populateAreasBySelectedRegions();
    setFilters();
}

function setSort(paramSortColumn, paramSortColumnIndex, paramSortOrder) {
    siteSearchFilters.sortColumn = paramSortColumn;
    siteSearchFilters.sortColumnIndex = paramSortColumnIndex;
    siteSearchFilters.desc = paramSortOrder;
    putFilterInStorage();
}

function putFilterInStorage() {
    if (typeof (Storage) !== "undefined") {
        sessionStorage.setItem("siteSearchFilters", JSON.stringify(siteSearchFilters));
    }
}

function setSitesTable(paramTable) {
    sitesTable = paramTable;
}

export const siteDashboardFilters = {
    init: init,
    doSetup: doSetup,
    getFilters: getFilters,
    setFilters: setFilters,
    clearFilters: clearFilters,
    getQueryStringFilters: getQueryStringFilters,
    setSort: setSort,
    setSitesTable: setSitesTable
};